<div>Hi ha hagut un error inesperat al servidor. Torni-ho a intentar mes endevant</div>
<button mat-button class="my-custom-button" (click)="close()" style="padding: 20px;">
    Tancar
</button>